import { Select, SelectProps } from "antd";
import { CustomerTags } from "../api/models";
import useCustomerTags from "../swr/useCustomerTags";

const CustomerTagSelector = (props: SelectProps) => {

  const customerTags = useCustomerTags();

  const tags = new Set<string>(Object.values(CustomerTags));
  customerTags.data?.forEach( t => tags.add(t) );

  return <Select
    mode="tags"
    allowClear
    loading={customerTags.isLoading}
    options={[...tags].sort().map( t => ({label: t, value: t}) )}
    {...props}
  />;
};

export default CustomerTagSelector;
